// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJ7fJqrAqqO4ah9fNpi2rEMl-Eu982aJc",
  authDomain: "miconvivir-35618.firebaseapp.com",
  projectId: "miconvivir-35618",
  storageBucket: "miconvivir-35618.firebasestorage.app",
  messagingSenderId: "1047500104847",
  appId: "1:1047500104847:web:fce71d7984537448e97cfa",
  measurementId: "G-TC353N37HN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);